import { Glasses, Sparkles } from "lucide-react";

export default function MontureCard({
    monture,
    onClick,
    size = "normal",
    showLimitedBadge = false,
}) {
    const isLarge = size === "large";
    const iconSize = isLarge ? 200 : 110;
    const hasImage = Boolean(monture.image);
    const limited = showLimitedBadge && monture.moment;

    return (
        <button
            type="button"
            onClick={onClick}
            className={`group relative w-full text-left overflow-hidden ${
                onClick ? "cursor-pointer" : "cursor-default"
            }`}
            style={{ backgroundColor: monture.bg, color: monture.fg }}
            data-testid={`monture-card-${monture.id}`}
        >
            {limited && (
                <span
                    className="absolute top-3 left-3 z-10 inline-flex items-center gap-1 px-2.5 py-1 text-[10px] uppercase tracking-[0.18em] font-bold shadow-md rotate-[-3deg]"
                    style={{ background: "#F2D580", color: "#0F2A20" }}
                    data-testid={`monture-card-badge-limited-${monture.id}`}
                >
                    <Sparkles size={10} strokeWidth={2.4} />
                    Du moment
                </span>
            )}
            <div className="aspect-[4/5] flex items-center justify-center overflow-hidden transition-transform duration-500 group-hover:scale-[1.04]">
                {hasImage ? (
                    <img
                        src={monture.image}
                        alt={`${monture.marque} ${monture.modele}`}
                        className="w-full h-full object-cover select-none"
                        draggable={false}
                    />
                ) : (
                    <Glasses size={iconSize} strokeWidth={1.3} />
                )}
            </div>
            <div
                className="px-5 py-4 border-t"
                style={{ borderColor: "currentColor", borderOpacity: 0.2 }}
            >
                <p className="font-serif italic text-sm opacity-80 leading-tight">
                    {monture.marque}
                </p>
                <h3 className="font-display font-semibold text-lg md:text-xl leading-tight tracking-tight mt-0.5">
                    {monture.modele}
                </h3>
            </div>
        </button>
    );
}
